import eventListeners from './event-listeners';
import documentMouseDownHandler from '../handlers/document-mouse-down-handler';

const mouseDownListener = (liveDocument) => {
  eventListeners.add(liveDocument, 'mousedown', documentMouseDownHandler);
};

export default mouseDownListener;
